import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

export function getMonitoredOfferCountsResourceQueryOptions() {
  return deferredResourceQueryOptions(orpc.deals.getMonitoredOfferCountsResource.queryOptions({}));
}
